<template>
  <div>
    <v-app-bar class="Vuely-toolbar" app fixed dark>
      <div class="d-custom-flex align-items-center navbar-left">
        <div class="site-logo-wrap d-custom-flex ml-0 align-items-center">
          <span class="site-logo-img">
            <a href="/">
              <logo class="logo ml-2 mt-4" id="logo"></logo>
            </a>
          </span>
        </div>
      </div>
      <div class="upgrade-btn" :class="currentHeader" id="menu-bar">
        <menu-bar></menu-bar>
      </div>
      <div class="navbar-right" style="display: flex; flex-wrap: wrap;">
        <!--  <v-btn class="my-2 mr-4 upgrade-btn font-weight-bold" outlined>connect wallet
        </v-btn> -->
        <!-- <v-btn class="v-step-2 mr-2 upgrade-btn font-weight-bold" outlined v-bind="attrs" v-on="on">disconnect
        </v-btn> -->
        <!-- <div class="profile-otr">
         <div class="profile-inr">
            <p class="price body-sb">
              0xc92c…61c725
            </p>
         </div>
       </div> -->
        <v-app-bar-nav-icon size="26" @click="drawer = true" class="pointer mr-2"></v-app-bar-nav-icon>
      </div>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" fixed right temporary app class="chat-sidebar-wrap" dark :width="300">
      <v-list nav dense>
        <v-list-item>
          <v-list-item-content>
            <router-link to="/">
              <logo></logo>
            </router-link>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list class="py-0" dense>
          <v-list-group class="fs-14">
            <template v-slot:activator>
              <v-list-item-content class="ml-4 my-1 text-hover">Artists</v-list-item-content>
            </template>
            <!--  Yin Kun -->
            <v-divider></v-divider>
            <div v-for="(artsit,index) in artsitList" :key="artsit.id">
              <router-link :to="'/artsit/' + artsit.author.toLowerCase().replace(' ', '')" class="del-underline white--text"
                data-testid="item-detail-link">
                <v-list-item class="white-hover">
                  <v-list-item-content class="ml-4 text-hover">
                    {{artsit.author}}
                  </v-list-item-content>
                </v-list-item>
              </router-link>
            </div>
          </v-list-group>
        </v-list>
          <v-list class="py-0" dense>
            <v-list-group>
              <template v-slot:activator>
                <v-list-item-content class="ml-4 my-1 text-hover fs-12">THE REMASTERED COLLECTION</v-list-item-content>
              </template>
              <!--  Yin Kun -->
              <v-divider></v-divider>
              <a href="/#today" class="white--text del-underline">
                <v-list-item class="white-hover">
                  <v-list-item-content class="ml-4 text-hover fs-12">
                    The TODAY Series
                  </v-list-item-content>
                </v-list-item>
              </a>
               </v-list-group>
          </v-list>
      </v-list>
      <v-list class="pt-0 pb-16">
        <!-- Discord -->
        <a href="https://discord.gg/mp4SYsKVTf" target="_blank" class="white--text del-underline">
          <v-list-item tile>
            <v-list-item-icon class="pl-1 mb-0">
              <v-icon>icon icon-discord</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </a>
        <!-- Twitter -->
        <a href="https://twitter.com/ArtWormz" target="_blank" class="white--text del-underline">
          <v-list-item tile>
            <v-list-item-icon class="pl-1 mb-0">
              <v-icon>icon icon-twitter</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </a>
        <!-- Telegram -->
        <a href="https://t.me/ArtWormzNFT" target="_blank" class="white--text del-underline">
          <v-list-item tile>
            <v-list-item-icon class="pl-1 mb-0">
              <v-icon>icon icon-telegram</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </a>
      </v-list>
    </v-navigation-drawer>
    <div class="mt-2">
      <a href="https://discord.gg/mp4SYsKVTf" target="_black" class="del-underline">
        <v-btn fixed fab x-small right bottom class="white--text gradient-btn">
          <v-icon>icon icon-discord</v-icon>
        </v-btn>
      </a>
    </div>
  </div>
</template>
<script>
  // $(function () {
  //     // $('#logo').hide();
  //     $('#menu-bar').hide();
  //     // 获取要大于的高度
  //     // 当滚动条的位置处于距顶部100像素以下时，跳转链接出现，否则消失
  //     $(function () {
  //         $(window).scroll(function(){
  //             if ($(window).scrollTop()>100){
  //                 // $("#logo").fadeIn(500);
  //                 $("#menu-bar").fadeIn(500);
  //             } else {
  //                 // $("#logo").fadeOut(500);
  //                 $("#menu-bar").fadeOut(0);
  //             }
  //         });
  //     });
  // })
  import Logo from '@/components/Logo';
  import MenuBar from '@/components/MenuBar';
  export default {
    data() {
      return {
        drawer: false,
        group: null,
        isShowConnectWalletMenu: false,
        currentRouter: this.$route.path,
        artsitList: [{
          id: 1,
          author: 'Yin Kun',
        }, {
          id: 2,
          author: 'Yin Jun',
        }, {
          id: 3,
          author: 'Huang Xi',
        }, {
          id: 4,
          author: 'Liu Yujun',
        }, {
          id: 5,
          author: 'Yang Peng',
        }, {
          id: 6,
          author: 'Liu Fei',
        }, {
          id: 7,
          author: 'Ma Yongqiang',
        }],

      }
    },
    created() {

    },
    components: {
      Logo,
      MenuBar
    },
    mounted() {

    },
    computed: {
      currentHeader(){
      	switch(this.currentRouter){
      		case '/': return 'menu-bar-none';
      		default: return 'menu-bar-show';
      	}
      }
    },
    watch: {
      $route(){
      	this.currentRouter = this.$route.path;
      }
    },
    methods: {},
  }
</script>
<style lang="scss" scoped>
  .logo {
    position: fixed;
    z-index: 999999999999;
    display: block;
    left: 0px;
    top: 0px;
    filter: alpha(opacity=80);
    cursor: pointer;
  }
  .menu-bar-none{
    z-index: 999;
    display: none;
  }
  .menu-bar-show{
    z-index: 999;
  }

  .theme--dark.v-list-item--active:hover::before,
  .theme--dark.v-list-item--active::before {
    opacity: 0 !important;
  }

  .profile-otr {
    position: relative;

    .profile-inr {
      position: relative;
      display: flex;
      align-items: center;
      height: 48px;
      transition: 0.3s;
      cursor: pointer;

      .creator {
        width: 32px;
        height: 32px;
        border-radius: 12px;
      }

      .price {
        color: #fff;
        margin: 0 16px;
      }

      .body-sb {
        font-size: 16px;
        line-height: 32px;
        font-family: "DMSans-Bold";
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue